export default __webpack_public_path__ + "static/media/data-unavailable.e9dd7d50.gif";